import {
    invalidTokenModalActions,
    InvalidTokenModalState
} from '../redux/slices/invalid-token-modal-slice';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { useCallback } from 'react';

const useInvalidTokenModal = () => {
    const state: InvalidTokenModalState = useAppSelector(
        (state) => state.invalidTokenModal
    );
    const dispatch = useAppDispatch();

    const showModal = useCallback((status: boolean) => {
        if (status) {
            dispatch(invalidTokenModalActions.showModal());
        } else {
            dispatch(invalidTokenModalActions.closeModal());
        }
    }, []);

    return { ...state, showModal };
};

export default useInvalidTokenModal;
